// extracted by mini-css-extract-plugin
export default {"mainPane":"TeamMembers_mainPane__b3fFw","itemDetails":"TeamMembers_itemDetails__hJlE1"};